<template>
<div>
    <div class="header_fixed">
        <div class="color_header" :style="{background: bg_color}">
            <div class="d-flex justify-space-between align-center">
                <div class="d-flex align-center">
                    <div class="logo_header">
                        <img :src="beforeImage">
                    </div>
                    <div class="pl-2 color_title_header">
                        <div v-if="$route.name != 'orderOnlinePickUp'">{{ $route.name == 'takeOutUser' ? $store.state.cartTakeOutNameUser : $route.name != 'takeOutUser' ? 'โต๊ะ '+ table_name : ''}}</div>
                        <div v-if="$route.name != 'orderOnlinePickUp'">{{ $route.name == 'buffetUser' ? 'บุฟเฟ่ต์' : $route.name == 'singleDishMealUser' ? 'ทานที่ร้าน' : $route.name == 'takeOutUser' || $route.name == 'takeOutUserTable' ? 'ซื้อกลับบ้าน' : '' }}</div>
                        <div v-if="$route.name == 'orderOnlinePickUp'">{{ $store.state.cartOrderOnlineNameUser.name }}</div>
                        <div v-if="$route.name == 'orderOnlinePickUp'">รับเองที่ร้าน {{ $store.state.cartOrderOnlineNameUser.time }}</div>
                    </div>
                </div>
                <div class="d-flex">

                    <div class="cart_all_header" @click="openTakeOutTable()" v-if="$route.name == 'buffetUser' && cart_type || $route.name == 'singleDishMealUser' && cart_type">
                        <div class="img_cart_header">
                            <img src="@/assets/take-away1.png">
                        </div>
                    </div>

                    <div class="cart_all_header" @click="$router.push('/myorder/'+ cart_type+'/'+$route.params.token)" v-if="$route.name == 'buffetUser' && cart_type || $route.name == 'singleDishMealUser' && cart_type">
                        <div class="img_cart_header">
                            <img src="@/assets/spoonandforkcircle.png">
                        </div>
                    </div>

                    <!-- <div class="cart_all_header" @click="$router.push('/cartmenu/'+ cart_type+'/'+$route.params.token)" v-if="$route.name == 'buffetUser' && cart_type || $route.name == 'singleDishMealUser' && cart_type">
                        <div class="img_cart_header">
                            <img src="@/assets/shopping-cart.png">
                        </div>
                        <div class="cart_number_header">
                            <div>{{ $store.state.cartListUser.length }}</div>
                        </div>
                    </div> -->

                    <!-- <div class="cart_all_header" @click="$router.push('/carttakeouttable/'+$route.params.token)" v-if="$route.name == 'takeOutUserTable'">
                        <div class="img_cart_header">
                            <img src="@/assets/shopping-cart.png">
                        </div>
                        <div class="cart_number_header">
                            <div>{{ $store.state.cartListTakeOutTable.length }}</div>
                        </div>
                    </div> -->
                    <div class="cart_all_header" @click="open_outtakeoutuser = true" v-if="$route.name == 'takeOutUser'">
                        <div class="img_cart_header">
                            <img src="@/assets/log-out.png">
                        </div>
                    </div>
                    <div class="cart_all_header" @click="open_outtakeoutuser = true" v-if="$route.name == 'orderOnlinePickUp'">
                        <div class="img_cart_header">
                            <img src="@/assets/log-out.png">
                        </div>
                    </div>
                    <!-- <div class="cart_all_header" @click="$router.push('/carttakeoutuser')" v-if="$route.name == 'takeOutUser'">
                        <div class="img_cart_header">
                            <img src="@/assets/shopping-cart.png">
                        </div>
                        <div class="cart_number_header">
                            <div>{{ $store.state.cartListUserTakeOut.length }}</div>
                        </div>
                    </div> -->
                </div>

            </div>
        </div>
        <div>
            <v-tabs grow :color="bg_color">
                <v-tab @click="page('buffet');" v-if="$route.name == 'buffetUser'">บุฟเฟ่ต์</v-tab>
                <v-tab @click="page('alacarte');">A La Carte</v-tab>
                <v-tab @click="page('drink');">เครื่องดื่ม</v-tab>
            </v-tabs>
        </div>
    </div>
    <v-dialog v-model="open_outtakeoutuser" persistent max-width="600">
        <v-card>
            <v-card-title class="justify-space-between">
                <div>ยกเลิกการสั่งซื้อใช่หรือไม่ ?</div>
                <div class="cursor_icon_header" @click="open_outtakeoutuser = false">
                    <v-icon>mdi-close</v-icon>
                </div>
            </v-card-title>

            <v-card-text>
                .
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" @click="outTakeOutUser()">
                    ใช่, ฉันต้องการยกเลิก
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import before_image from "@/assets/new_logo_by.png";
export default {
    data() {
        return {
            beforeImage: before_image,
            bg_color: 'linear-gradient(to top, #038cc1 , #55c0e9)',
            title: this.$route.name == 'buffetUser' ? 'buffet' : 'alacarte',
            cart_type: null,
            open_outtakeoutuser: false
        }
    },
    props: ['table_name', 'table_type', 'table_detail'],
    methods: {
        async colorRestaurant() {
            HTTP.get('/showColor')
                .then((response) => {
                    if (response.data.successful === true) {
                        this.bg_color = response.data.color_code
                        this.beforeImage = response.data.logo_image
                        this.loading_page = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                    if (error.response.status === 500) {
                        this.$router.push('/nametakeoutuser')
                    }

                })
        },
        async page(name) {
            this.title = name
            this.$emit('getTypeMenu', name)
        },
        async openTakeOutTable() {
            const idPage = {
                id: this.$route.params.id
            }

            this.$store.commit('detailTakeOutTablePage', idPage)
            let routeData = this.$router.resolve({
                name: 'takeOutUserTable'
            });
            window.open(routeData.href, '_blank');
        },
        async outTakeOutUser() {
            if (this.$route.name == 'takeOutUser') {
                this.$store.commit('clearCartListUserTakeOut')
                this.$router.push('/nametakeoutuser')
            }
            if (this.$route.name == 'orderOnlinePickUp') {
                this.$store.commit('clearCartOrderOnlineUser')
                this.$router.push('/nameorderonlinepickup')
            }
        }
    },
    mounted() {
        this.colorRestaurant()
        this.page(this.title)
    },
    watch: {
        table_type: function (val) {
            if (val === 'บุฟเฟ่') {
                this.cart_type = 'buffetuser/' + this.$route.params.id
            }
            if (val === 'ไม่บุฟเฟ่') {
                this.cart_type = 'singledishmealuser/' + this.$route.params.id
            }
            if (val === 'takeoutuser') {
                this.cart_type = 'takeoutuser/home'
            }
            if (val === 'orderonlinepickup') {
                this.cart_type = 'orderonlinepickup/home'
            }
        }
    }
}
</script>

<style scoped>
.header_fixed {
    position: fixed;
    width: 100%;
    z-index: 2;
}

.color_header {
    background: linear-gradient(to top, #038cc1, #55c0e9)
}

.logo_header {
    width: 60px;
}

.logo_header>img {
    max-width: 100%;
}

.color_title_header {
    color: #fff;
}

.cart_all_header {
    position: relative;
    cursor: pointer;
}

.cart_all_header {
    margin-right: 15px;
}

.img_cart_header {
    width: 37px;
}

.img_cart_header>img {
    max-width: 100%;
}

.cart_number_header {
    position: absolute;
    top: -5px;
    right: -10px;
    border-radius: 50%;
    width: 15px;
    text-align: center;
    background: #ffffff;
    color: #038cc1;
    font-size: 12px;
}

.cursor_icon_header {
    cursor: pointer;
}
</style>
